import { z } from 'zod'
import { optionalText, requiredNumber, requiredText } from '../../../lib/forms/rules'

/**
 * Değerlendirme kriteri ekle/düzenle form şeması (028): nameTr zorunlu; nameEn opsiyonel; weight zorunlu
 * tam sayı 0–100 (0 dâhil — Clarifications 2026-07-14). Sıra (SORT_INDEX) formda yok — tablodaki ↑/↓
 * oklarından yapılır (oluşturmada sona otomatik atanır). Aralık/tamsayı kuralı `superRefine` ile eklenir
 * (tip bozulmaz; hata `weight` alanına düşer).
 */
export const criteriaScoreFormSchema = z
  .object({
    nameTr: requiredText(255),
    nameEn: optionalText(255),
    weight: requiredNumber(),
  })
  .superRefine((v, ctx) => {
    if (v.weight !== null && (!Number.isInteger(v.weight) || v.weight < 0 || v.weight > 100)) {
      ctx.addIssue({ code: 'custom', message: 'validation.weightRange', path: ['weight'] })
    }
  })

export type CriteriaScoreFormValues = z.infer<typeof criteriaScoreFormSchema>
